import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  "class": "flex justify-start mb-8 max-w-3xl"
};
var _hoisted_2 = {
  "class": "text-3xl font-bold"
};
var _hoisted_3 = /*#__PURE__*/_createTextVNode("Users");
var _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-indigo-400 font-medium"
}, "/", -1);
var _hoisted_5 = ["src"];
var _hoisted_6 = /*#__PURE__*/_createTextVNode(" This user has been deleted. ");
var _hoisted_7 = {
  key: 1,
  "class": "max-w-3xl bg-white rounded-md shadow overflow-hidden"
};
var _hoisted_8 = {
  "class": "flex flex-wrap -mb-8 -mr-6 p-8"
};
var _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  value: "admin"
}, "ADMIN", -1);
var _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  value: "dgm"
}, "DGM", -1);
var _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  value: "sbu_head"
}, "SBU HEAD", -1);
var _hoisted_12 = /*#__PURE__*/_createElementVNode("option", {
  value: "team_lead"
}, "TEAM LEAD", -1);
var _hoisted_13 = {
  "class": "flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100"
};
var _hoisted_14 = /*#__PURE__*/_createTextVNode("Update User");
var _hoisted_15 = {
  key: 2,
  "class": "max-w-3xl bg-white rounded-md shadow overflow-hidden"
};
var _hoisted_16 = {
  "class": "flex flex-wrap -mb-8 -mr-6 p-8"
};
var _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  value: "admin"
}, "ADMIN", -1);
var _hoisted_18 = /*#__PURE__*/_createElementVNode("option", {
  value: "dgm"
}, "DGM", -1);
var _hoisted_19 = /*#__PURE__*/_createElementVNode("option", {
  value: "sbu_head"
}, "SBU HEAD", -1);
var _hoisted_20 = {
  "class": "flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100"
};
var _hoisted_21 = /*#__PURE__*/_createTextVNode("Update User");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_Link = _resolveComponent("Link");
  var _component_trashed_message = _resolveComponent("trashed-message");
  var _component_text_input = _resolveComponent("text-input");
  var _component_select_input = _resolveComponent("select-input");
  var _component_file_input = _resolveComponent("file-input");
  var _component_loading_button = _resolveComponent("loading-button");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "".concat($data.form.first_name, " ").concat($data.form.last_name)
  }, null, 8, ["title"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("h1", _hoisted_2, [_createVNode(_component_Link, {
    "class": "text-indigo-400 hover:text-indigo-600",
    href: "/users"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_3];
    }),
    _: 1
  }), _hoisted_4, _createTextVNode(" " + _toDisplayString($data.form.first_name) + " " + _toDisplayString($data.form.last_name), 1)]), $props.user.photo ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    "class": "block ml-4 w-8 h-8 rounded-full",
    src: $props.user.photo
  }, null, 8, _hoisted_5)) : _createCommentVNode("", true)]), $props.user.deleted_at ? (_openBlock(), _createBlock(_component_trashed_message, {
    key: 0,
    "class": "mb-6",
    onRestore: $options.restore
  }, {
    "default": _withCtx(function () {
      return [_hoisted_6];
    }),
    _: 1
  }, 8, ["onRestore"])) : _createCommentVNode("", true), $props.authUserType == 'admin' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("form", {
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(function () {
      return $options.update && $options.update.apply($options, arguments);
    }, ["prevent"]))
  }, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_text_input, {
    modelValue: $data.form.first_name,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.form.first_name = $event;
    }),
    error: $data.form.errors.first_name,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "First name"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.last_name,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.form.last_name = $event;
    }),
    error: $data.form.errors.last_name,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Last name"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.email,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.form.email = $event;
    }),
    error: $data.form.errors.email,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Email"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.password,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.form.password = $event;
    }),
    error: $data.form.errors.password,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    type: "password",
    autocomplete: "new-password",
    label: "Password"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_select_input, {
    modelValue: $data.form.user_type,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.form.user_type = $event;
    }),
    error: $data.form.errors.user_type,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "User Type"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_9, _hoisted_10, _hoisted_11, _hoisted_12];
    }),
    _: 1
  }, 8, ["modelValue", "error"]), _createVNode(_component_file_input, {
    modelValue: $data.form.photo,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return $data.form.photo = $event;
    }),
    error: $data.form.errors.photo,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    type: "file",
    accept: "image/*",
    label: "Photo"
  }, null, 8, ["modelValue", "error"])]), _createElementVNode("div", _hoisted_13, [!$props.user.deleted_at ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    "class": "text-red-600 hover:underline",
    tabindex: "-1",
    type: "button",
    onClick: _cache[6] || (_cache[6] = function () {
      return $options.destroy && $options.destroy.apply($options, arguments);
    })
  }, "Delete User")) : _createCommentVNode("", true), _createVNode(_component_loading_button, {
    loading: $data.form.processing,
    "class": "btn-indigo ml-auto",
    type: "submit"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_14];
    }),
    _: 1
  }, 8, ["loading"])])], 32)])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("form", {
    onSubmit: _cache[14] || (_cache[14] = _withModifiers(function () {
      return $options.update && $options.update.apply($options, arguments);
    }, ["prevent"]))
  }, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_text_input, {
    modelValue: $data.form.first_name,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
      return $data.form.first_name = $event;
    }),
    error: $data.form.errors.first_name,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "First name"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.last_name,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
      return $data.form.last_name = $event;
    }),
    error: $data.form.errors.last_name,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Last name"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.email,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
      return $data.form.email = $event;
    }),
    error: $data.form.errors.email,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Email",
    disabled: ""
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.password,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
      return $data.form.password = $event;
    }),
    error: $data.form.errors.password,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    type: "password",
    autocomplete: "new-password",
    label: "Password"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_select_input, {
    modelValue: $data.form.user_type,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
      return $data.form.user_type = $event;
    }),
    error: $data.form.errors.user_type,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "User Type",
    disabled: ""
  }, {
    "default": _withCtx(function () {
      return [_hoisted_17, _hoisted_18, _hoisted_19];
    }),
    _: 1
  }, 8, ["modelValue", "error"]), _createVNode(_component_file_input, {
    modelValue: $data.form.photo,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
      return $data.form.photo = $event;
    }),
    error: $data.form.errors.photo,
    "class": "pb-8 pr-6 w-full lg:w-1/2 hidden",
    type: "file",
    accept: "image/*",
    label: "Photo",
    disabled: ""
  }, null, 8, ["modelValue", "error"])]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_loading_button, {
    loading: $data.form.processing,
    "class": "btn-indigo ml-auto",
    type: "submit"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_21];
    }),
    _: 1
  }, 8, ["loading"])])], 32)]))]);
}